// extracted by mini-css-extract-plugin
export var compactFilters = "_cy-4";
export var detailImage = "_cy-1";
export var dropdownContainer = "_cy-2";
export var imageContainer = "_cy-0";
export var selectedCard = "_cy-3";